import ExceptionLogger from './exceptionLogger';

export default ExceptionLogger;
